import baseDeepDiveContent from "./DeepDiveContent.en";
import { translateResults } from "../i18n/translate";

const lang = "th";
const t = (text) => translateResults(lang, text);

const TITLE_OVERRIDES = {
  "Digital Wellbeing Environment at Home": "สภาพแวดล้อมดิจิทัลเพื่อสุขภาพที่ดีที่บ้าน",
  "Family Communication on Digital Wellbeing and AI":
    "การสื่อสารภายในครอบครัวเกี่ยวกับสุขภาวะดิจิทัลและปัญญาประดิษฐ์ (AI)",
  "Parental Resourcefulness and Self-Efficacy":
    "ความสามารถในการแก้ไขปัญหาและความเชื่อมั่นในตนเองของผู้ปกครอง",
  "School-Parent Communication": "การสื่อสารระหว่างผู้ปกครองและโรงเรียน",
};

const deepDiveContent = Object.fromEntries(
  Object.entries(baseDeepDiveContent).map(([key, section]) => [
    key,
    {
      ...section,
      title: TITLE_OVERRIDES[key] || section.title,
      importance: Array.isArray(section.importance)
        ? section.importance.map((p) => t(p))
        : [],
    },
  ])
);

export default deepDiveContent;

